import React, { useImperativeHandle, useRef, useState } from "react";
import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import { ResidentModel } from "app/services/api/types/residents/models/ResidentModel";
import { ModifyResidentRef } from "app/features/residents/templates/interfaces";
import { View } from "ui/atoms/view";
import { Button, ButtonText } from "ui/gluestack/button";
import { ResidentProvider } from "app/features/residents/provider/ResidentProvider";
import { ResidentAllergiesFormTemplate } from "../modify/ResidentAllergiesFormTemplate";
import { ResidentDietFormTemplate } from "../modify/ResidentDietFormTemplate";
import { FormButtons } from "../../molecules/FormButtons";

interface Ref {
  show: (initialResident?: ResidentModel) => void;
}

const EditResidentAllergiesModal = React.forwardRef<Ref, unknown>((_, ref) => {
  const [showing, setShowing] = useState(false);
  const [initialResident, setInitialResident] = useState<ResidentModel>();
  const editAllergiesRef = useRef<ModifyResidentRef>(null);
  const editDietRef = useRef<ModifyResidentRef>(null);

  useImperativeHandle(ref, () => ({
    show: (initialResident?: ResidentModel) => {
      setInitialResident(initialResident);
      setShowing(true);
    },
  }));

  const handleClose = () => {
    setShowing(false);
  };

  const handleSave = async () => {
    const respAllergies = await editAllergiesRef.current?.continue();
    const respDiet = await editDietRef.current?.continue();
    if (respAllergies && respDiet) setShowing(false);
  };

  return (
    <ReusableModal
      isVisible={showing}
      onClose={handleClose}
      className="w-full max-w-[984px] mx-auto"
      title={`Allergies & Dietary requirements`}
      hasCancelButton
      isEditing
    >
      <ResidentProvider residentModel={initialResident}>
        <>
          <ResidentAllergiesFormTemplate ref={editAllergiesRef} />
          <View className="mt-10">
            <ResidentDietFormTemplate ref={editDietRef} />
          </View>

          <FormButtons onClose={handleClose} onSave={handleSave} />
        </>
      </ResidentProvider>
    </ReusableModal>
  );
});

EditResidentAllergiesModal.displayName = "EditResidentAllergiesModal";
export { EditResidentAllergiesModal };
